import React from 'react'

export const LeftSVG = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 50 52" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path d="M0 26L49.5 0.0192375V51.9808L0 26Z" fill="#233A8B"/>
        </svg>
    );
}
